/**
 * 初始化全局api
 */

import {
  each,
  events,
  isFn,
  noop
} from '../util';

// 4.X版本重写makeBridgeFn
import {
  oldMakeBridgeFn,
  registerHandler
} from '../core/old_bridge';

import {
  init,
  makeBridgeFn
} from '../core/bridge';

// 引入beatles bridge处理
import {
  initBeatles
} from '../beatles/index';

import {
  initApp,
  inApp,
  compareAppVersion,
  app,
  isAndroid,
  isFusionKit
} from './app';

import {
  initShare
} from './share';

import {
  initIS
} from './is';

let makeBridgeFunction = makeBridgeFn;

import config from '../config';

export function initGlobalAPI(DDBridge) {
  initIS(DDBridge);
  initApp(DDBridge);
  init();
  initBaseCall(DDBridge);
  proxy(DDBridge);
  initSupport(DDBridge);
  initShare(DDBridge);

  if (!isFusionKit() && compareAppVersion('<', '5.0.0')) {
    makeBridgeFunction = oldMakeBridgeFn;
    oldInitEvents(DDBridge);
  } else {
    initEvents(DDBridge);
  }

  // 初始化beatles扩展
  initBeatles(DDBridge);
};

/**
 * 基础的Bridge.call(name,param,callback)方法
 * @param DDBridge
 */
function initBaseCall(DDBridge) {
  DDBridge.call = function (name, param, callback) {
    let conf = config.api[name];
    let bridgeFn = makeBridgeFunction(name, conf, config);
    if (!callback && isFn(param)) {
      callback = param;
      param = {};
    }
    return bridgeFn(param, callback);
  };
}

/**
 * 事件绑定接口
 * @param DDBridge
 */
function initEvents(DDBridge) {
  DDBridge.on = function (eventName, callback) {
    events.on(eventName, callback);
  };

  DDBridge.off = function (eventName, callback) {
    events.un(eventName, callback);
  };
}

function initSupport(DDBridge) {
  DDBridge.support = function (fn, cpVersion) {
    // 如果不是app或者该方法未收录,返回false
    if (!inApp() || !DDBridge[fn]) {
      return false;
    }
    let support = DDBridge[fn].support;
    if (!support || compareAppVersion(cpVersion || app.version, '>=', support)) {
      return true;
    }
    return false;
  };
}

/**
 * api接口代理, 只代理收录的方法
 * @param DDBridge
 */
function proxy(DDBridge) {
  each(config.api, (conf, name) => {
    DDBridge[name] = makeBridgeFunction(name, conf);
    DDBridge[name].support = conf.support;
  });
}

function oldInitEvents(DDBridge) {
  if (isAndroid()) {
    DDBridge.on = function (eventName, callback) {
      events.on(eventName, callback);
    };

    DDBridge.off = function (eventName, callback) {
      events.un(eventName, callback);
    };

    DDBridge._trigger = events.emit;
  } else {
    DDBridge.on = registerHandler;

    DDBridge.off = noop;
  }
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/global-api/index.js